import React, { useState, useEffect } from "react";
import { Row, Button, Spinner, Col } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useTranslation } from "react-i18next";
import draftToHtml from "draftjs-to-html";
import configVars from "../config";
import { useDispatch } from "react-redux";
import { addComment } from "../redux/actions/tasks";
import { convertToRaw } from "draft-js";
const Replies = ({
  show,
  handleClose,
  selectedComment,
  color,
  tasklist_id,
  task_id,
  onClickSaveHideEditor,
  onAddReply,
  taskType,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");
  const [loading, setLoading] = useState(null);
  const [reply, setReply] = useState(null);
  const [replyContent, setReplyContent] = useState(null);
  const [isBlocking, setIsBlocking] = useState(false);
  const [sentReplyButton, setSentReplyButton] = useState(false);
  // const [allReplies, setAllReplies] = useState([]);
  // useEffect(() => {
  //   if (selectedComment) {
  //     if (selectedComment?.children) {
  //       setAllReplies(selectedComment?.children);
  //     }
  //   }
  // }, [selectedComment]);

  useEffect(() => {
    var element = document.getElementById("reply-editor");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, []);

  const handleAddReply = async () => {
    try {
      setLoading(true);
      let commentObj = {
        task_id: task_id,
        // tasklist_id: tasklist_id,
        comment_parent: selectedComment?.comment_id,
        comment: draftToHtml(replyContent),
      };

      let _comment = await dispatch(
        addComment({
          comment: commentObj,
          taskId: task_id,
          listId: tasklist_id,
          taskType: taskType,
        })
      );
      onClickSaveHideEditor();
      if (_comment.status !== "error") {
        onAddReply(_comment.data);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }

    setReply(null);
    setReplyContent(null);
  };
  return (
    <>
      <div id="reply-editor">
        <Row className="mt-1">
          <Col lg="12">
            <>
              <Editor
                toolbar={configVars?.wysiwygToolbarOptions}
                editorState={reply}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editor-wrapper"
                onEditorStateChange={(e) => setReply(e)}
                onChange={(e) => {
                  setReplyContent(e);
                  let draft = draftToHtml(e);
                  const isEmpty = convertToRaw(
                    reply.getCurrentContent()
                  ).blocks.every((b) => b.text.trim() === "");
                  if (!isEmpty) {
                    setSentReplyButton(true);
                  } else {
                    setSentReplyButton(false);
                  }

                  if (
                    !isBlocking &&
                    draft.replace("<p>&nbsp;</p>", "").trim().length > 0
                  ) {
                    setIsBlocking(true);
                  }
                }}
                placeholder={translation("task_forms.replies.placeholder")}
              />

              <div className="d-flex justify-content-end">
                {sentReplyButton && isBlocking ? (
                  <>
                    <Button
                      variant={`${color} text-white rounded`}
                      className="m-2"
                      disabled={loading}
                      size="sm"
                      onClick={handleAddReply}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          style={{ color: "#fff" }}
                        />
                      ) : (
                        translation("buttons.reply")
                      )}
                    </Button>
                    <Button
                      variant={`${color} text-white rounded`}
                      className="m-2"
                      disabled={loading}
                      size="sm"
                      onClick={handleClose}
                    >
                      {translation("buttons.cancel")}
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Replies;

// add reply | reply comment | respond comment
